import { isClient } from "~/utils/env_check";
import { fetchEmailSuggestion } from "~/utils/email_address_validator";

type Args = {
  email: string;
  urlToken: string;
};

const submitNotificationRequest = async ({ email, urlToken }: Args) => {
  const jobSeekersUrl = isClient() && window.ENV.JOB_SEEKERS_URL;
  let response;

  try {
    const suggestion = await fetchEmailSuggestion(email);

    if (suggestion) {
      console.info({ suggestion });
    }

    response = await fetch(`${jobSeekersUrl}/api/sessions`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email, job_board: urlToken }),
    });
  } catch (e) {
    console.error(`Failed to submit notification email - ${e}`);
    throw e;
  }

  return response.json();
};

export default submitNotificationRequest;
